<template>
  <div>
    <div style="min-height: 100vh; width: 100%; background-color: #272727;">
      <div
        style="width: 100%; height: 60px; position: fixed; padding: 20px 40px; display: flex; align-items: center; gap: 5px">
        <div style="width: 40px; height: 40px">
          <a href="https://app.atosa.asia/">
            <img src="/static/img/logo.png" alt="user_logo" style="width: 100%; height: 100%; object-fit: contain"/>
          </a>
        </div>
      </div>

      <div style="display: flex; justify-content: center; padding: 3rem; width: 100%; padding-top: 80px">
        <div v-if="component === 'form'" style="max-width: 700px; display: flex; flex-direction: column">
          <div style="color: #DADADA; font-size: 18px; font-weight: bold; text-align: center">
            Form đăng ký sử dụng tính năng tự động tối ưu Quảng cáo bằng Atosa Agent AI
          </div>

          <div>
            <form style="margin-top: 60px; display: flex; flex-direction: column; gap: 30px" ref="form">
              <div>
                <div style="font-size: 13px; color: #dadada">
                  Họ và tên
                  <b style="color: #eb4d4d">*</b>
                </div>
                <div>
                  <input v-model="fullname" type="text" class="custom-input" placeholder="Nhập họ và tên"
                         :required="true">
                </div>
              </div>

              <div>
                <div style="font-size: 13px; color: #dadada">
                  Số điện thoại
                  <b style="color: #eb4d4d">*</b>
                </div>
                <div>
                  <input v-model="phone" type="text" class="custom-input"
                         placeholder="Nhập số điện thoại để chúng tôi có thể liên hệ với bạn"
                         :required="true">
                </div>
              </div>

              <div>
                <div style="font-size: 13px; color: #dadada">
                  Email:
                  <b style="color: #eb4d4d">*</b>
                </div>
                <div>
                  <input v-model="email" type="text" class="custom-input" placeholder="Nhập email" :required="true">
                </div>
              </div>

              <div>
                <div style="font-size: 13px; color: #dadada">
                  Link shop:
                  <b style="color: #eb4d4d">*</b>
                </div>
                <div>
                <textarea v-model="shop_link" type="text" class="custom-input" :required="true"
                          placeholder="Nhập link shop (Nhấn Enter để xuống dòng nếu quý khách có nhiều shop)"
                          rows="4"></textarea>
                </div>
              </div>

              <div v-if="false">
                <div style="font-size: 13px; color: #dadada">
                  Ngành hàng của shop hiện tại là gì?
                  <b style="color: #eb4d4d">*</b>
                </div>
                <div>
                  <input v-model="shop_category" type="text" class="custom-input" placeholder="Nhập ngành hàng"
                         :required="true">
                </div>
              </div>

              <div>
                <div style="font-size: 13px; color: #dadada">
                  Doanh thu tháng của shop hiện tại đang là bao nhiêu?
                  <b style="color: #eb4d4d">*</b>
                </div>
                <div>
                  <input v-model="shop_gmv" type="text" class="custom-input" placeholder="Nhập doanh thu"
                         :required="true">
                </div>
              </div>

              <div>
                <div style="font-size: 13px; color: #dadada">
                  Shop có đang thuê nhân viên hay agency để chạy quảng cáo không?
                  <b style="color: #eb4d4d">*</b>
                </div>
                <div style="margin-top: 10px">
                  <div style="display: flex; flex-direction: column; gap: 20px">
                    <div
                      v-for="item in radio_list"
                      style="border: 1px solid #dadada; border-radius: 10px; display: flex; align-items: center; padding: 10px 10px">
                      <el-radio v-model="radio" :label="item.label" style="margin: 0 !important;"
                                class="custom-el-radio">
                        <strong style="color: #dadada">
                          {{ item.text }}
                        </strong>
                      </el-radio>
                    </div>
                  </div>
                </div>
              </div>

              <template v-if="['1','2'].includes(radio)">
                <div>
                  <div style="font-size: 13px; color: #dadada">
                    Hiện tại mỗi tháng shop đang phải chi ra bao nhiêu tiền để trả cho nhân sự hoặc thuê agency cho việc
                    chạy ads và vận hành?
                    <b style="color: #eb4d4d">*</b>
                  </div>
                  <div>
                    <input v-model="cost_of_operation" type="text" class="custom-input"
                           placeholder="Nhập số tiền chi trả" :required="['1','2'].includes(radio)">
                  </div>
                </div>

                <div>
                  <div style="font-size: 13px; color: #dadada">
                    Quy mô nhân sự hiện tại đang là bao nhiêu người?
                    <b style="color: #eb4d4d">*</b>
                  </div>
                  <div>
                    <input v-model="staff_number" type="text" class="custom-input" placeholder="Nhập số lượng nhân sự">
                  </div>
                </div>
              </template>

              <template v-if="['3'].includes(radio)">
                <div>
                  <div style="font-size: 13px; color: #dadada">
                    Hiện tại shop dành ra bao nhiêu tiếng 1 ngày để chỉnh ads và vận hành shop?
                    <b style="color: #eb4d4d">*</b>
                  </div>
                  <div>
                    <input v-model="spend_time_for_operation" type="text" class="custom-input"
                           placeholder="Nhập số thời gian" :required="['3'].includes(radio)">
                  </div>
                </div>
              </template>

              <div v-if="false">
                <div style="font-size: 13px; color: #dadada">
                  Mong muốn của shop là gì khi muốn áp dụng AI vào việc vận hành chạy quảng cáo?
                  <b style="color: #eb4d4d">*</b>
                </div>
                <div style="margin-top: 10px">
                  <div style="display: flex; flex-direction: column; gap: 20px">
                    <div
                      v-for="item in checkbox_list"
                      style="border: 1px solid #dadada; border-radius: 10px; display: flex; align-items: center; padding: 10px 10px; gap: 10px">
                      <input type="checkbox" :id="item.label" :name="item.label" v-model="item.checked"
                             class="custom-checkbox"/>
                      <label :for="item.label" class="custom-label">
                        {{ item.text }}
                      </label>
                    </div>

                    <div v-if="checkbox_list.some(i => i.label === '5' && i.checked)">
                      <input v-model="other_hope" type="text" class="custom-input"
                             placeholder="Nhập mong muốn của quý khách"
                             :required="checkbox_list.some(i => i.label === '5' && i.checked)">
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div style="font-size: 13px; color: #dadada">
                  Mong muốn của shop là gì khi muốn áp dụng AI vào việc vận hành chạy quảng cáo?
                  <b style="color: #eb4d4d">*</b>
                </div>
                <div>
                <textarea v-model="other_hope" type="text" class="custom-input" :required="true"
                          placeholder="Chúng tôi đang thu thập các trường hợp sử dụng mà bạn mong muốn thử nghiệm nhất với Atosa. Ý tưởng của bạn là gì? Bạn cung cấp càng nhiều chi tiết về nhu cầu của mình, chúng tôi càng có thể điều chỉnh giải pháp phù hợp với bạn hơn."
                          rows="4"></textarea>
                </div>
              </div>

              <div style="padding: 20px; display: flex; justify-content: center">
                <button type="submit" class="custom-button" :disabled="loading.send_request" @click="m__send_request">
                  <i v-if="loading.send_request" class="el-icon-loading"></i>
                  Gửi yêu cầu
                </button>
              </div>

            </form>
          </div>
        </div>

        <div v-if="component === 'thanks'" style="width: 600px">
          <div style="color: #DADADA; font-size: 20px; font-weight: bold; text-align: center">
            Cảm ơn quý khách đã tin tưởng và đồng hành cùng Atosa
          </div>
          <div v-if="true" style="margin-top: 20px; font-size: 14px; color: #7b7b7b; text-align: center">
            Chúng tôi đã nhận được thông tin đăng ký của bạn và rất trân trọng sự quan tâm dành cho Atosa Agent AI.
            Đội ngũ của chúng tôi sẽ xem xét thông tin bạn cung cấp và sẽ sớm liên hệ lại qua số điện thoại bạn đã đăng
            ký.
            Một lần nữa, cảm ơn bạn đã đồng hành cùng Atosa!
          </div>
          <div v-if="false" style="margin-top: 20px; font-size: 14px; color: #7b7b7b; text-align: center">
            Chúng tôi đã nhận được thông tin đăng ký của bạn và rất trân trọng sự quan tâm dành cho Atosa Agent AI.
            Lượt đăng ký đợt 1 đã kết thúc và đóng lại. Chúng tôi sẽ xem xét thông tin bạn cung cấp và sẽ sớm liên hệ
            lại qua số điện thoại bạn đã đăng ký.
          </div>
          <div style="margin-top: 20px; display: flex; justify-content: center">
            <button type="submit" class="custom-button" style="width: 250px" @click="$router.push('/')">
              Quay trở lại Atosa
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      component: 'form',

      fullname: '',
      phone: '',
      email: '',
      shop_link: '',
      shop_category: '',
      shop_gmv: '',
      cost_of_operation: '',
      staff_number: '',
      spend_time_for_operation: '',
      radio: null,
      radio_list: [
        {
          label: '1',
          text: 'Có, tôi đang thuê nhân viên để chạy quảng cáo'
        },
        {
          label: '2',
          text: 'Có, tôi đang thuê agency để chạy quảng cáo'
        },
        {
          label: '3',
          text: 'Không, tôi tự chạy quảng cáo'
        }
      ],
      checkbox_list: [
        {
          label: '1',
          text: 'Tiết kiệm thời gian',
          checked: false
        },
        {
          label: '2',
          text: 'Tăng doanh thu, giảm chi phí',
          checked: false
        },
        {
          label: '3',
          text: 'Tăng traffic, tối ưu CIR',
          checked: false
        },
        {
          label: '4',
          text: 'Không cần thuê nhân viên chạy ads',
          checked: false
        },
        {
          label: '5',
          text: 'Mong muốn khác',
          checked: false
        }
      ],
      other_hope: '',

      loading: {
        send_request: false
      }
    }
  },

  methods: {
    async m__send_request(event) {
      event.preventDefault()

      const form = this.$refs.form;
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!this.radio) {
        this.ntf_w('Vui lòng điền đầy đủ các thông tin')
        return
      }

      // if (!this.checkbox_list.some(i => i.checked)) {
      //   this.ntf_w('Vui lòng điền đầy đủ các thông tin')
      //   return
      // }
      //
      // if (this.checkbox_list.some(i => i.label === '5' && i.checked) && !this.other_hope) {
      //   this.ntf_w('Vui lòng điền đầy đủ các thông tin')
      //   return
      // }

      this.loading.send_request = true
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/form/register_ai', {
          fullname: this.fullname,
          phone: this.phone,
          email: this.email,
          shop_link: this.shop_link,
          shop_category: this.shop_category,
          shop_gmv: this.shop_gmv,
          cost_of_operation: this.cost_of_operation,
          staff_number: this.staff_number,
          spend_time_for_operation: this.spend_time_for_operation,
          radio: this.radio_list.find(i => i.label === this.radio).text,
          checkbox_list: this.checkbox_list.filter(i => i.checked).map(i => i.text),
          other_hope: this.other_hope
        }, this.cf())
        await this.sleep(1000)
        this.component = 'thanks'
      } catch (e) {
        this.ntf_w('Đã có lỗi xảy ra. Xin vui lòng thử lại sau!')
      } finally {
        this.loading.send_request = false
      }
    }
  }
}
</script>

<style>
.custom-input {
  margin-top: 8px;
  width: 100%;
  border-radius: 10px;
  background-color: #363537;
  box-sizing: border-box;
  outline: none;
  padding: 9px 12px;
  border: 0 solid #e5e7eb;
  color: #dadada;
  font-size: 14px;
  resize: none;
}

.custom-checkbox {
  width: 15px !important;
  height: 15px !important;
  margin: 0 !important;
  cursor: pointer;
}

.custom-label {
  font-size: 12px;
  color: #dadada;
  margin: 0 !important;
  cursor: pointer;
}

.custom-button {
  color: #000000e6;
  font-size: 15px;
  line-height: 38px;
  font-weight: bold;
  padding: 0 15px;
  border: none;
  outline: none;
  border-radius: 10px;
  background-color: #fff;
  width: 360px;
  margin-bottom: 20px;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
  transition-duration: .15s;
}

.custom-button:hover {
  opacity: .9;
}

.custom-el-radio .el-radio__input.is-checked .el-radio__inner {
  background-color: #0670ff !important;
  border-color: #0670ff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/form/ai_form.vue